<template>
    <div class="container">
        <div class="container-swipe">
            <van-swipe :autoplay="3000"
                       indicator-color="white">
                <van-swipe-item v-for="item in images"
                                :key="item">
                    <img :src="item"
                         alt="">
                </van-swipe-item>
            </van-swipe>
        </div>
    </div>
</template>

<script>
// /shared-book/627509707090386953
import { querySharedBookInfo } from "@/api";

export default {
    name: "SharedBook",
    // 组件
    components: {},
    props: {},
    data () {
        return {
            images: []
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取共享广告册信息
        getSharedBookInfo () {
            let params = {
                showcaseId: this.$route.params.id
            }
            querySharedBookInfo(params).then(res => {
                if (Number(res.code) === 20000) {
                    if (!res.data) {
                        return
                    }
                    let list = res.data || []
                    this.images = list.map(item => {
                        return item.image
                    })
                } else {
                    this.$toast.fail(res.msg);
                }
            }).catch(err => {
                this.$toast.fail(err);
            })
        },
    },
    // 创建完成
    created () {
    },
    // 挂载完成
    mounted () {
        this.getSharedBookInfo()
    },
    // 销毁之前
    beforeDestroy () {
    }
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    .container-swipe {
        width: 100%;
        height: 100%;
        ::v-deep .van-swipe {
            width: 100%;
            height: 100%;
            img {
                width: 100%;
                height: 100%;
                object-fit: contain;
            }
        }
    }
}
</style>
